import { Box } from 'components/Box';
import { FilestackImage } from 'components/Image';
import { TrackedConditionalLink } from 'components/Link';
import { Body } from 'components/Text/Body';
import { BodySmall } from 'components/Text/BodySmall';
import { H2 } from 'components/Text/H2';
import { CmsApiImageBlockData } from 'modules/cms/api/types/CmsApiImage';

type Props = {
  data: CmsApiImageBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsAmpImageBlock({
  data: { headline, subtitle, image, url },
  blockIndex,
  pageUpdated,
}: Props) {
  const { caption, altText } = image;

  return (
    <Box as="figure" m={0} w={1}>
      {(headline || subtitle) && (
        <Box as="figcaption" mb={48}>
          {headline && <H2>{headline}</H2>}
          {subtitle && (
            <Body
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            />
          )}
        </Box>
      )}

      <Box as={headline || subtitle ? 'figure' : 'div'} m={0}>
        <TrackedConditionalLink
          link={url}
          eventName="CMS Block"
          eventProperties={{
            block_position: blockIndex,
            block_type: 'Image',
            cta_type: 'Image',
            page_updated: pageUpdated,
          }}
        >
          <FilestackImage
            data={image}
            alt={altText || ''}
            height={450}
            width={1152}
            objectPosition="left"
          />
        </TrackedConditionalLink>

        {caption && (
          <BodySmall mt="8px" as="figcaption">
            {caption}
          </BodySmall>
        )}
      </Box>
    </Box>
  );
}
